export enum InputMasks {
	ZipCode = "99999-999",
	Cpf = "999.999.999-99",
	Cnpj = "99.999.999/9999-99",
}
